import React from 'react'
import { format } from 'date-fns'
import Svg from '_components/svg'

import CloseIcon from '_assets/icons/ic-close-circle.svg'
import SaveIcon from '_assets/icons/ic-tick-circle.svg'

const Default = ({ value, styles }) => {
  return (
    <div className={styles.default}>
      {value ? (
        <Svg icon={SaveIcon} className={styles.icon} />
      ) : (
        <Svg icon={CloseIcon} className={styles.icon} />
      )}
    </div>
  )
}

export const FILTER_DEFAULT_VALUES = {
  aiAssistant: '',
  isPrompt: '',
  userName: '',
  statusApi: '',
}

const apiStatusMap = {
  pending: 'Pendente',
  rejected: 'Reprovado',
  approved: 'Aprovado',
  processed: 'Processado',
  error: 'Erro',
}

export const PROMPTS_OPTIONS = [
  { value: '', label: '(Todos)' },
  { value: true, label: 'Sim' },
  { value: false, label: 'Não' },
]

export const STATUS_API_OPTIONS = [
  { value: 'pending', label: 'Pendente' },
  { value: 'rejected', label: 'Reprovado' },
  { value: 'approved', label: 'Aprovado' },
  { value: 'processed', label: 'Processado' },
  { value: 'error', label: 'Erro' },
]

export const IaTrainigColumns = styles => [
  {
    field: 'aiAssistant',
    headerName: 'Item de IA',
    width: 200,
    editable: false,
    renderCell: ({ value }) => value?.name,
  },
  {
    field: 'createdAt',
    headerName: 'Data',
    width: 150,
    editable: false,
    renderCell: params => {
      const date = new Date(params.value)
      return format(date, 'dd/MM/yyyy HH:mm')
    },
  },
  {
    field: 'userName',
    headerName: 'Usuário',
    width: 200,
    editable: false,
  },
  {
    field: 'isPrompt',
    headerName: 'Prompt',
    width: 80,
    editable: false,
    renderCell: ({ value }) => <Default value={value} styles={styles} />,
  },
  {
    field: 'explanation',
    headerName: 'Explicações',
    flex: 1,
    editable: false,
  },
  {
    field: 'statusApi',
    headerName: 'Status API',
    width: 100,
    editable: false,
    renderCell: ({ value }) => apiStatusMap[value] || '-',
  },
]
